import { BottomSheet, type UseModalState } from "@clipboard-health/ui-components";

import { VisitBottomSheetContent } from "./Content";
import { VisitBottomSheetFooter } from "./Footer";
import { VisitBottomSheetHeader } from "./Header";

interface VisitBottomSheetProps {
  modalState: UseModalState;
}

export function VisitBottomSheet(props: VisitBottomSheetProps) {
  const { modalState } = props;

  return (
    <BottomSheet
      modalState={modalState}
      paperSx={{ height: "100%" }}
      footer={<VisitBottomSheetFooter />}
    >
      <VisitBottomSheetHeader />
      <VisitBottomSheetContent />
    </BottomSheet>
  );
}
